import { Component, Input } from '@angular/core';
import { MbExpandableText } from '@am/moebius';

@Component({
  selector: 'am-seo-search',
  standalone: true,
  styleUrls: ['./seo-search.component.scss'],
  templateUrl: './seo-search.component.html',
  imports: [MbExpandableText],
})
export class SeoSearchComponent {
  @Input()
  public destination: any;

  constructor() {}
}
